export default __webpack_public_path__ + "static/media/DevPlans.50b5501a.svg";